import {Context, createContext} from "react";

export type IRecordsContext = {
  records: any[];
}
export const RecordsContext: Context<IRecordsContext> = createContext<IRecordsContext>({records:[]})
export const SelectedRecordsContext: Context<IRecordsContext> = createContext<IRecordsContext>({records:[]})

export type IFileAttributes = {
  type: string | undefined,
  size: string | undefined
}

export type IContext = {
  context: string | null;
}
export const CardContext: Context<IContext> = createContext<IContext>({context: null})

